export const LANGUAGE = {
  en_EN: "English",
  ru_RU: "Russian",
  de_DE: "Dutch"
};
